module.exports = __webpack_public_path__ + "static/media/1019035.41397f53.jpg";